module.exports = __webpack_public_path__ + "static/media/icono_completo_tarjetas.de98d018.svg";